/* eslint-disable @typescript-eslint/no-explicit-any */
import { get } from '_core/config/api/Api';
import { IFinalResponse, InitApiType } from '_core/types';
import Definitions from '../Definitions';
import { HeadlessDeliveryTypes } from '../Types';

type ApiParamsTypes = {
  flatter?: true | false;
  filter?: HeadlessDeliveryTypes.HeadlessDeliverySearchType[];
  fields?: string[];
};

const definitions = Definitions.GetHeadlessDelivery;

export const callGet = async (
  params: ApiParamsTypes,
): Promise<IFinalResponse> => {
  const init: InitApiType = {
    params: {},
    headers: {
      'Accept-Language': 'pt-BR',
    },
  };

  init.params.flatten = params.flatter;
  init.params.filter = params.filter
    ?.map((item) => `(${item.param} ${item.conditional} '${item.value}')`)
    .join(' or ');

  if (params?.fields) init.params.fields = params?.fields?.join(',');

  return get(
    definitions.API_DOMAIN,
    definitions.ENDPOINT_API_PATH,
    definitions.API_CREDENTIALS_TYPE,
    init,
  );
};
const call = { get: callGet };

export default { call, definitions };
